// UI Component: TabBar
import { Tab } from '../modules/types';

export class TabBar {
  private element: HTMLElement;
  private tabsContainer: HTMLElement;
  private callbacks: {
    onTabSwitch?: (tabId: string) => void;
    onTabClose?: (tabId: string) => void;
    onNewTab?: () => void;
  } = {};

  constructor(element: HTMLElement) {
    this.element = element;
    this.tabsContainer = element.querySelector('#tabs-container')!;
    this.bindEvents();
  }

  private bindEvents(): void {
    const btnNewTab = this.element.querySelector('#btn-new-tab');
    btnNewTab?.addEventListener('click', () => this.callbacks.onNewTab?.());
  }

  on(event: string, callback: (tabId: string) => void): void {
    if (event === 'tabSwitch') this.callbacks.onTabSwitch = callback;
    if (event === 'tabClose') this.callbacks.onTabClose = callback;
    if (event === 'newTab') this.callbacks.onNewTab = callback as any;
  }

  render(tabs: Tab[], activeTabId: string | null): void {
    this.tabsContainer.innerHTML = '';

    tabs.forEach((tab) => {
      const tabElement = document.createElement('div');
      tabElement.className = `tab ${tab.id === activeTabId ? 'active' : ''}`;
      tabElement.dataset.tabId = tab.id;

      const label = document.createElement('span');
      label.className = 'tab-label';
      label.textContent = tab.fileName;

      const unsavedIndicator = document.createElement('span');
      unsavedIndicator.className = 'tab-unsaved';
      unsavedIndicator.textContent = tab.unsaved ? '*' : '';

      const closeBtn = document.createElement('button');
      closeBtn.className = 'tab-close';
      closeBtn.textContent = '×';
      closeBtn.title = 'Close';
      closeBtn.onclick = (e) => {
        e.stopPropagation();
        this.callbacks.onTabClose?.(tab.id);
      };

      tabElement.appendChild(label);
      tabElement.appendChild(unsavedIndicator);
      tabElement.appendChild(closeBtn);

      tabElement.onclick = () => {
        this.callbacks.onTabSwitch?.(tab.id);
      };

      this.tabsContainer.appendChild(tabElement);
    });
  }
}
